
import React from "react";
import ValueProposition from "@/components/ValueProposition";
import { Check } from "lucide-react";

const RothseeSection: React.FC = () => {
  return (
    <ValueProposition
      title="Der Rothsee: Coaching in der Natur in Bayern"
      description="Der Rothsee im Fränkischen Seenland bietet mit seiner weitläufigen Landschaft, den gepflegten Wegen und der ruhigen Atmosphäre perfekte Bedingungen für intensives Coaching in der Natur. Die Kombination aus Wasser, Wald und Wiesen schafft einen inspirierenden Raum für neue Gedanken und Perspektiven."
      image="/lovable-uploads/80e133cf-1b30-47a0-9ec2-5e3bd2118aa3.png"
      backgroundColor="bg-white"
      reverse={true}
    >
      <div className="mt-2 space-y-3">
        <div className="flex items-start gap-3">
          <Check className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-joerg-600">
            Leicht erreichbar aus Nürnberg, Fürth, Erlangen und dem Umland
          </span>
        </div>
        <div className="flex items-start gap-3">
          <Check className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-joerg-600">
            Verschiedene Routen für unterschiedliche Coaching-Formate
          </span>
        </div>
        <div className="flex items-start gap-3">
          <Check className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-joerg-600">
            Ruhige Plätze für fokussierte Gespräche und Reflexionsphasen
          </span>
        </div>
      </div>
    </ValueProposition>
  );
};

export default RothseeSection;
